// Email sends are rate limited at the load balancer, not by the mail provider, so the 429 never
// reaches the API and nothing server-side can absorb it.

// Four attempts over a minute.
export const RETRY_DELAYS_MS = [10000, 20000, 30000]

export const RATE_LIMIT_MESSAGE = 'The email cannot be sent at this time. Please try again later.'

// Excludes the response-less case: the request may have reached the API and sent before the
// response was lost, and retrying that duplicates the email.
export const isRateLimited = (error) => error?.response?.status === 429

const wait = (ms) => new Promise((resolve) => setTimeout(resolve, ms))

const exhausted = (lastError) => {
  const error = new Error(RATE_LIMIT_MESSAGE)
  error.isRateLimited = true
  error.cause = lastError
  return error
}

// Anything that is not a 429 is rethrown as-is; once the delays run out this throws an error
// carrying RATE_LIMIT_MESSAGE and isRateLimited.
export async function sendWithRetry(send, { onRetry, delays = RETRY_DELAYS_MS } = {}) {
  for (let attempt = 0; ; attempt++) {
    try {
      return await send()
    } catch (error) {
      if (!isRateLimited(error)) {
        throw error
      }
      if (attempt >= delays.length) {
        throw exhausted(error)
      }

      const waitMs = delays[attempt]
      if (onRetry) {
        onRetry({ attempt: attempt + 1, of: delays.length, waitMs })
      }
      await wait(waitMs)
    }
  }
}
